export default __webpack_public_path__ + "static/team-galo-8873e6022e4ca484c16346c5b8464dbc.png";